(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iglam-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.iglam-card-swatches__button');
    if (!button) return;
    event.preventDefault();
    const card = button.closest('.card-main');
    const swatches = button.closest('.iglam-card-swatches');
    if (!card || !swatches) return;

    const image = card.querySelector('.card--image > .featured-media');
    if (image && button.dataset.image) {
      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      image.alt = button.dataset.imageAlt;
      image.loading = 'eager';
    }

    const secondary = card.querySelector('.card-secondary-image');
    if (secondary) {
      const secondaryImage = secondary.querySelector('img');
      if (secondaryImage && button.dataset.secondaryImage) {
        secondaryImage.removeAttribute('srcset');
        secondaryImage.src = button.dataset.secondaryImage;
        secondary.style.removeProperty('display');
      } else {
        secondary.style.display = 'none';
      }
    }

    card.querySelectorAll('.card--image, .card-title a').forEach((link) => {
      link.href = button.dataset.variantUrl;
    });
    swatches.querySelectorAll('button').forEach((swatch) => {
      swatch.setAttribute('aria-pressed', String(swatch === button));
    });
    swatches.querySelector('.iglam-card-swatches__status').textContent = button.dataset.colour + ' selected';
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iglam-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('iglam-coupon')) {
    customElements.define('iglam-coupon', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', event => event.stopPropagation());
        this.addEventListener('submit', event => {
          event.preventDefault();
          event.stopPropagation();
          this.applyCode();
        });
      }

      async applyCode() {
        if (this.busy) return;
        const input = this.querySelector('input[name="discount"]');
        const button = this.querySelector('button');
        const status = this.querySelector('.iglam-coupon__status');
        const code = input.value.trim();
        if (!code) { input.focus(); return; }
        this.busy = true;
        button.disabled = true;
        input.readOnly = true;
        this.setAttribute('aria-busy', 'true');
        status.textContent = '';
        status.dataset.error = 'false';
        try {
          const cartUrl = this.dataset.cartUrl;
          const currentResponse = await fetch(`${cartUrl}.js`, {headers: {Accept: 'application/json'}});
          if (!currentResponse.ok) throw new Error('cart');
          const current = await currentResponse.json();
          const codes = (current.discount_codes || []).filter(discount => discount.applicable).map(discount => discount.code);
          const applications = [...(current.cart_level_discount_applications || []), ...(current.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
          codes.push(...applications.filter(discount => discount.type === 'discount_code').map(discount => discount.title));
          const requested = [...new Map([...codes, code].map(value => [value.toUpperCase(), value])).values()];
          const body = {discount: requested.join(',')};
          if (this.dataset.instance === 'drawer') {
            body.sections = ['cart-drawer', 'cart-icon-bubble'];
            body.sections_url = window.location.pathname;
          }
          const response = await fetch(`${cartUrl}/update.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
          if (!response.ok) throw new Error('update');
          const data = await response.json();
          const result = (data.discount_codes || []).find(discount => discount.code.toUpperCase() === code.toUpperCase());
          if (!result || !result.applicable) {
            status.textContent = this.dataset.invalid;
            status.dataset.error = 'true';
            return;
          }
          const success = this.dataset.success;
          const drawer = this.closest('cart-drawer');
          if (drawer && data.sections && data.sections['cart-drawer'] && data.sections['cart-icon-bubble']) {
            drawer.renderContents(data);
            const newStatus = drawer.querySelector('.iglam-coupon__status');
            if (newStatus) newStatus.textContent = success;
          } else {
            window.location.reload();
          }
        } catch {
          status.textContent = this.dataset.error;
          status.dataset.error = 'true';
        } finally {
          this.busy = false;
          button.disabled = false;
          input.readOnly = false;
          this.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
